"use client";

import { useState } from "react";
import { cn } from "@eg/ui";

type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
  src?: string | null;
  fallbackSrc?: string;
};

export default function ImageWithFallback({
  src,
  alt,
  className,
  fallbackSrc = "/Logo.png",
  ...rest
}: Props) {
  const [errored, setErrored] = useState(!src || src.length === 0);
  const finalSrc = !src || errored ? fallbackSrc : (src as string);
  return (
    <img
      src={finalSrc}
      alt={alt || "Bild nicht verfügbar"}
      className={cn("block", className)}
      onError={() => setErrored(true)}
      {...rest}
    />
  );
}
